import React, { useState } from 'react';
import { ArrowLeft, ChevronDown, ChevronUp } from 'lucide-react';
import { useNavigate } from 'react-router';



const CategoryAndSubCategories = () => {

    const navigate = useNavigate();
    const [expandedSections, setExpandedSections] = useState({
        hr: true,
        sales: false,
        leadership: false,
        customerService: false
    });

    const toggleSection = (section) => {
        setExpandedSections(prev => ({
            ...prev,
            [section]: !prev[section]
        }));
    };

    const [isVisible, setIsVisible] = useState(false);

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '32px',

        }}>
            {/* Header */}
            <div style={{
                display: "flex",
                alignItems: "center",
                gap: "16px"
            }}>
                <button
                    onClick={() => navigate('/roleplayManagement/editscenario')}
                    style={{
                        width: "42px",
                        height: "42px",
                        borderRadius: "50%",
                        background: "#FFFFFF",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        backdropFilter: "blur(10px)"
                    }}
                >
                    <ArrowLeft size={20} color="#171717" />
                </button>
                <h1
                    className='font-clash-display'
                    style={{
                        fontFamily: "ClashDisplay-Semibold",
                        fontWeight: "600",
                        fontSize: "24px",
                        lineHeight: "32px",
                        color: "#374151",
                        margin: 0
                    }}
                >
                    Categories and subcategories mangement
                </h1>
            </div>
            <div style={{
                display: "grid",
                gridTemplateColumns: '50% 50%',
                columnGap: "24px"
                // backgroundColor: '#f8fafc'
            }}>
                {/* Left Container - Categories */}
                <div style={{
                    backgroundColor: '#FFFFFF',
                    borderRadius: '16px',
                    padding: '32px',
                    height: 'fit-content',
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                }}>
                    <h2 style={{
                        fontSize: '24px',
                        lineHeight: "32px",
                        fontFamily: "ClashDisplay-Semibold",
                        fontWeight: 600,
                        color: '#000000',
                        // margin: '0 0 24px 0'
                    }}>
                        Categories
                    </h2>

                    {/* HR Section */}
                    <div style={{
                        display: 'flex',
                        flexDirection: "column",
                        gap: "6px"
                    }}>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                cursor: 'pointer',
                                color: '#374151'
                            }}
                            onClick={() => toggleSection('hr')}
                        >
                            <span style={{
                                fontSize: '16px',
                                lineHeight: "24px",
                                fontWeight: '600',
                                verticalAlign: 'middle',
                                color: '#4B5563',
                                fontFamily: 'Plus Jakarta Sans'
                            }}>HR</span>
                            {expandedSections.hr ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                        </div>

                        {expandedSections.hr && (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                <div style={{
                                    backgroundColor: '#EFFCFB',
                                    border: '1px solid #23B4C3',
                                    borderRadius: '8px',
                                    padding: '8px',
                                    fontSize: '14px',
                                    color: '#0f172a',

                                }}>
                                    <span style={{
                                        fontSize: '14px',
                                        lineHeight: "20px",
                                        fontWeight: '400',
                                        verticalAlign: 'middle',
                                        color: '#6B7280',
                                        fontFamily: 'Plus Jakarta Sans'
                                    }}>
                                        Employee Conflict Resolution
                                    </span>

                                </div>
                                <div style={{
                                    backgroundColor: '#EFFCFB',
                                    border: '1px solid #23B4C3',
                                    borderRadius: '8px',
                                    padding: '8px',
                                    fontSize: '14px',
                                    color: '#0f172a',
                                }}>
                                    <span style={{
                                        fontSize: '14px',
                                        lineHeight: "20px",
                                        fontWeight: '400',
                                        verticalAlign: 'middle',
                                        color: '#6B7280',
                                        fontFamily: 'Plus Jakarta Sans'
                                    }}>
                                        Performance Improvement and Feedback
                                    </span>

                                </div>
                                <div style={{
                                    backgroundColor: '#EFFCFB',
                                    border: '1px solid #23B4C3',
                                    borderRadius: '8px',
                                    padding: '8px',
                                    fontSize: '14px',
                                    color: '#0f172a',
                                }}>
                                    <span style={{
                                        fontSize: '14px',
                                        lineHeight: "20px",
                                        fontWeight: '400',
                                        verticalAlign: 'middle',
                                        color: '#6B7280',
                                        fontFamily: 'Plus Jakarta Sans'
                                    }}>
                                        Sensitive Employee Conversations
                                    </span>

                                </div>
                            </div>
                        )}

                        <div style={{
                            color: '#23B4C3',
                            fontSize: '12px',
                            lineHeight: "18px",
                            fontWeight: 400,
                            fontFamily: 'Plus Jakarta Sans',
                            cursor: 'pointer',
                            textDecoration: 'underline',
                        }}>
                            Add more subcategory
                        </div>
                    </div>

                    {/* Sales Section */}
                    <div >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                cursor: 'pointer',
                                padding: '12px 0',
                                fontSize: '16px',
                                fontWeight: '500',
                                color: '#374151'
                            }}
                            onClick={() => toggleSection('sales')}
                        >
                            <span style={{
                                fontSize: '16px',
                                lineHeight: "24px",
                                fontWeight: '600',
                                verticalAlign: 'middle',
                                color: '#4B5563',
                                fontFamily: 'Plus Jakarta Sans'
                            }}>Sales</span>
                            {expandedSections.sales ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                        </div>
                    </div>

                    {/* Leadership Section */}
                    <div >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                cursor: 'pointer',
                                padding: '12px 0',
                                fontSize: '16px',
                                fontWeight: '500',
                                color: '#374151'
                            }}
                            onClick={() => toggleSection('leadership')}
                        >
                            <span style={{
                                fontSize: '16px',
                                lineHeight: "24px",
                                fontWeight: '600',
                                verticalAlign: 'middle',
                                color: '#4B5563',
                                fontFamily: 'Plus Jakarta Sans'
                            }} >Leadership</span>
                            {expandedSections.leadership ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                        </div>
                    </div>

                    {/* Customer Service Section */}
                    <div>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                cursor: 'pointer',
                                padding: '12px 0',
                                fontSize: '16px',
                                fontWeight: '500',
                                color: '#374151'
                            }}
                            onClick={() => toggleSection('customerService')}
                        >
                            <span style={{
                                fontSize: '16px',
                                lineHeight: "24px",
                                fontWeight: '600',
                                verticalAlign: 'middle',
                                color: '#4B5563',
                                fontFamily: 'Plus Jakarta Sans'
                            }}>Customer service</span>
                            {expandedSections.customerService ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                        </div>
                    </div>
                </div>

                {/* Right Container - Employee Conflict Resolution */}
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: 'white',
                    borderRadius: '16px',

                    padding: '32px',
                    height: 'fit-content',
                    gap: "24px"
                }}>
                    <h2 style={{
                        fontFamily: "ClashDisplay-Semibold",
                        fontSize: '24px',
                        fontWeight: '600',
                        lineHeight: "32px",
                        color: '#000000',
                        // margin: '0 0 32px 0'
                    }}>
                        Employee Conflict Resolution
                    </h2>

                    {/* Title Section */}
                    <div style={{}}>
                        <label style={{
                            fontFamily: 'Plus Jakarta Sans',
                            display: 'block',
                            fontSize: '14px',
                            fontWeight: '700',
                            color: '#6b7280',
                            marginBottom: '8px', lineHeight: '20px'
                        }}>
                            Title
                        </label>
                        <div style={{
                            backgroundColor: '#f9fafb',
                            border: '1px solid #d1d5db',
                            borderRadius: '6px',
                            padding: '12px 16px',
                            fontSize: '14px',
                            color: '#374151',
                            fontStyle: 'italic'
                        }}>
                            Employee Conflict Resolution
                        </div>
                    </div>

                    {/* Description Section */}
                    <div style={{ marginBottom: '24px' }}>
                        <label style={{
                            fontFamily: 'Plus Jakarta Sans',
                            display: 'block',
                            fontSize: '14px',
                            fontWeight: '700',
                            color: '#6b7280',
                            marginBottom: '8px',
                            lineHeight: '20px'
                        }}>
                            Description
                        </label>
                        <div style={{
                            backgroundColor: '#f9fafb',
                            border: '1px solid #d1d5db',
                            borderRadius: '6px',
                            padding: '12px 16px',
                            fontSize: '14px',
                            color: '#374151',
                            fontStyle: 'italic',
                            lineHeight: '1.5'
                        }}>
                            You are an HR professional conducting a one-on-one meeting with an employee whose performance has been
                        </div>
                    </div>

                    {/* Visibility Toggle Section */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        // marginBottom: '32px'
                    }}>
                        <label style={{
                            fontSize: '14px',
                            fontWeight: '700',
                            lineHeight: "20px",
                            fontFamily: 'Plus Jakarta Sans',
                            color: '#6b7280'
                        }}>
                            Visibility toggle
                        </label>
                        <div
                            style={{
                                width: '44px',
                                height: '24px',
                                backgroundColor: isVisible ? '#23b4c3' : '#e5e7eb',
                                borderRadius: '12px',
                                position: 'relative',
                                cursor: 'pointer',
                                transition: 'background-color 0.2s'
                            }}
                            onClick={() => setIsVisible(!isVisible)}
                        >
                            <div style={{
                                width: '20px',
                                height: '20px',
                                backgroundColor: '#FFFFFF',
                                borderRadius: '50%',
                                position: 'absolute',
                                top: '2px',
                                left: isVisible ? '22px' : '2px',
                                transition: 'left 0.2s',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                            }} />
                        </div>
                    </div>

                    {/* Save Button */}
                    <button className="next-button" style={{
                        backgroundColor: '#0891b2',
                        color: 'white',
                        border: 'none',
                        borderRadius: '24px',
                        padding: '12px 32px',
                        fontSize: '16px',
                        fontWeight: '500',
                        cursor: 'pointer',
                        transition: 'background-color 0.2s'
                    }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#0e7490'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#0891b2'}
                    >
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CategoryAndSubCategories;